
const getDefaultState = () => {
  return {
    log: {
      subject_type: 'App\\Controllers\\Default',
    }
  }
}

const state = getDefaultState();

const getters = {
  getLog(state) {
    return state.log;
  },
};

const mutations = {
  setLog(state, val) {
    state.log = val;
  },
  resetLog(state) {
    state.log = getDefaultState().log;
  },
};

const actions = {
  setLog: ({commit}, val) => {
      commit('setLog', val);
  },
  resetLog: ({commit}) => {
      commit('resetLog');
  },
};

export default { namespaced: true, state, mutations, getters, actions };
